import * as api_config from '../config/api_config'
import qs from 'qs'

export default {
    getProduct(axios, slug, params) {
        return axios.get(`${api_config.ADDRESS}/products/${slug}`, { params, headers: api_config.HEADERS})
    },
    getProductsByParams(axios, params = {}) {
        const finalParams = { ...params, searchable: true }
        const url = `${api_config.ADDRESS}/admin/products?${qs.stringify(finalParams)}`
        return axios.get(url, {headers: api_config.HEADERS})
    }
}
